import { render, staticRenderFns } from "./BillsDetailCard.vue?vue&type=template&id=54cda842&scoped=true&"
import script from "./BillsDetailCard.vue?vue&type=script&lang=js&"
export * from "./BillsDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./BillsDetailCard.vue?vue&type=style&index=0&id=54cda842&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cda842",
  null
  
)

export default component.exports